import {IackathonSaveState} from './iackathon-save.state';
import {IACKATHON_STEP, IACKATHON_STEP_LABEL_KEY} from './iackathon_steps';

export type IackathonStepStatus = 'completed' | 'locked' | null;

export function isIackathonStepCompleted(
    state: IackathonSaveState | null | undefined,
    step: IACKATHON_STEP,
): boolean {
    if (!state) return false;

    switch (step) {
        case 'keyNumber':
            return state.sdg_theme_step.top_group_answers.first_number.length > 0
                && state.sdg_theme_step.top_group_answers.second_number.length > 0
                && state.sdg_theme_step.top_group_answers.third_number.length > 0;
        case 'problematic':
            return state.problem_step.problematic.length > 0;
        case 'howNowWow':
            return state.dashboard.matrix_slot.complete;
        case 'finalIdea':
            return state.dashboard.final_idea.complete;
        case 'canvas':
            return state.dashboard.canvas.complete;
        case 'deliverable':
            return state.dashboard.deliverable.complete;
        case 'ratingOthers':
            return Object.keys(state.groups_project_reviews).length > 0;
        case 'rate':
            return false;
        default:
            return false;
    }
}

export function isIackathonStepLocked(
    state: IackathonSaveState | null | undefined,
    step: IACKATHON_STEP,
): boolean {
    const stepsOrder = Object.keys(IACKATHON_STEP_LABEL_KEY) as IACKATHON_STEP[];
    const stepIndex = stepsOrder.indexOf(step);
    if (stepIndex < 0) return true;
    if (stepIndex === 0) return false;

    return !isIackathonStepCompleted(state, stepsOrder[stepIndex - 1]);
}
